import React from 'react';
import { MetaTag } from 'src/components';
// import BannerImg from 'src/assets/image/home/thumbnail.jpg';
import CurrentPoolV2 from './components/CurrentPoolV2';
import Features from './components/FeaturesV2';
import Introduce from './components/Introduce';
import UpgradeYourTiers from './components/UpgradeYourTiers';
import UpComingPoolV2 from './components/UpComingPoolV2';
import { Wrapper } from './HomeV2.styled';
import PartnersV2 from './components/PartnersV2';
import BackersV2 from './components/BackersV2';
import HotNew from './components/HotNew';

function HomeV2() {
    // const introduce = useParallax({
    //     speed: isMobile ? 20 : 50,
    // });r
    return (
        <Wrapper>
            <MetaTag title="" description="" image="" />
            <Introduce />
            <HotNew />
            <CurrentPoolV2 />
            <UpgradeYourTiers />
            <UpComingPoolV2 />
            <Features />
            <BackersV2 />
            <PartnersV2 />
        </Wrapper>
    );
}
export default HomeV2;
